export default __webpack_public_path__ + "a6c529096e7e27c39202b80da5d5b40c.svg";